import { render } from "./Index.vue?vue&type=template&id=6e1ca76c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Blog/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e1ca76c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e1ca76c', __exports__)) {
    api.reload('6e1ca76c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=6e1ca76c", () => {
    api.rerender('6e1ca76c', render)
  })

}


export default __exports__